export const es = {
    translation: {
        b: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
            send: 'Enviar',
            done: 'Listo',
            close: 'Cerrar',
            clear: 'Limpiar',
            copy_link: 'Copiar enlace',
            export: 'Exportar',
            delete: 'Eliminar',
            delete_confirm: 'Confirmar eliminación',
            duplicate: 'Duplicar',
            share: 'Compartir',
            sign_in: 'Iniciar sesión',
            sign_up: 'Registrarse',
            email_address: 'Correo electrónico',
            yes: 'Sí',
            no: 'No',
            back: 'Atrás',
            upgrade: 'Mejorar',
            remove: 'Quitar',
            restore: 'Restaurar',
            archive: 'Archivar',
            rename: 'Renombrar',
            leave: 'Salir',
            import: 'Importar',
            continue: 'Continuar',
            settings: 'Configuración',
            log_out: 'Cerrar sesión',
            invite: 'Invitar',
            invited: 'Invitado',
        },
        roles: {
            view: 'Lector',
            comment: 'Comentador',
            edit: 'Editor',
            admin: 'Administrador',
            owner: 'Propietario',
            member: 'Miembro',
            remove: 'Quitar',
            more_roles: 'Más roles...',
            change_role: 'Cambiar rol...',
            remove_access: 'Quitar acceso...',
            remove_invite: 'Quitar invitación...',
        },
        db_engine: {
            basic: 'SQL básico',
            general: 'SQL general',
        },
        socket_status: {
            reconnecting: 'Reconectando...',
            offline: 'Estás sin conexión. Reconectando...',
        },
        loader: {
            diagram: 'Cargando diagrama...',
        },
        m_languages: {
            title: 'Idiomas',
            subtitle: 'Elige un idioma'
        },
        m_feedback: {
            feature: {
                name: 'Solicitud de función',
                desc: '¿Falta alguna función que necesitas? Cuéntanos — tus ideas importan'
            },
            feedback: {
                name: 'Comparte tu opinión',
                desc: 'Nos encantaría saber qué piensas'
            },
            support: {
                name: 'Soporte',
                desc: '¿Algo no funciona? Cuéntanos — lo solucionaremos rápido',
            },
            bug: {
                name: 'Reportar un problema',
                desc: '¿Algo no va bien? Repórtalo — lo resolveremos rápido',
            },
            integration: {
                name: 'Solicitar integración',
                desc: 'Tus comentarios son muy importantes para nosotros — deja una nota breve',
            }
        },
        m_feedback_t: {
            feature: {
                name: '¡Gracias por tu sugerencia!',
                desc: 'Agradecemos de verdad que te tomes el tiempo para compartir tus ideas — nos ayuda a mejorar.'
            },
            feedback: {
                name: '¡Gracias por tus comentarios!',
                desc: 'Agradecemos de verdad que te tomes el tiempo para compartir tus ideas — nos ayuda a mejorar.'
            },
            support: {
                name: '¡Gracias por contactarnos!',
                desc: 'Gracias por contactar a soporte — revisaremos tu solicitud y te responderemos lo antes posible.',
            },
            bug: {
                name: '¡Gracias por tu reporte!',
                desc: 'Gracias por reportar esto — nos ayuda a resolver problemas más rápido y a seguir mejorando la experiencia.',
            },
            contact: {
                name: '¡Gracias por contactarnos!',
                desc: 'Hemos recibido tu mensaje y te responderemos lo antes posible.',
            },
            invite_people: {
                name: '¡Invitación enviada correctamente!',
                desc: 'Gracias por correr la voz — estamos deseando darles la bienvenida.',
            },
            integration: {
                name: '¡Gracias por tu sugerencia!',
                desc: 'Agradecemos de verdad que te tomes el tiempo para compartir tus ideas — nos ayuda a mejorar.',
            },
        },
        m_diagram_details: {
            name_place: 'Introduce el nombre del proyecto',
            desc_place: 'Introduce la descripción del proyecto'
        },
        m_quick_share: {
            title: 'Compartir rápido',
            subtitle: '(Por enlace)'
        },
        m_export_img: {
            title: 'Exportar imagen'
        },
        search_menu: {
            placeholder: 'Buscar tablas, columnas, tipos...',
            hint: '',
            no_results: 'Sin resultados',
            quick_results: 'Resultados rápidos para',
            untitled: 'sin título',
            command_tag: 'comando',
            section_tables: 'Tablas',
            section_columns: 'Columnas',
            section_canvas: 'Lienzo',
            section_export: 'Exportar',
            section_preferences: 'Preferencias',
            section_settings: 'Configuración',
            type_table: 'tabla',
            type_note: 'nota',
            cmd_new_table: 'Crear nueva tabla...',
            cmd_new_note: 'Crear nueva nota...',
            cmd_new_line: 'Crear nueva línea...',
            cmd_new_area: 'Crear nueva área...',
            cmd_export_image: 'Exportar imagen...',
            cmd_export_sql: 'Exportar código SQL...',
            cmd_grid_style: 'Cambiar vista de cuadrícula...',
        },
        canvas_table: {
            more_column: 'columna más',
            more_columns: 'columnas más',
            tooltip_table: 'Tabla',
            tooltip_indexes: 'Índices',
            tooltip_enum: 'Enum',
            tooltip_default: 'Predeterminado',
            tooltip_generated: 'Generado',
            tooltip_check: 'Check',
        },
        m_export_code: {
            title: 'Exportar código {{db_engine}}',
            download_file: 'Descargar archivo',
            copy_code: 'Copiar código'
        },
        m_sign_in_remind: {
            title: 'Gracias por probar DB Design',
            subtitle: 'Inicia sesión o regístrate para aumentar el número máximo de tablas, guardar diagramas y desbloquear más funciones.'
        },
        m_sign_in_restrict: {
            title: 'Inicia sesión para hacer más en la app',
            subtitle: 'Inicia sesión o regístrate para aumentar los límites de tablas, guardar diagramas y desbloquear más funciones.'
        },
        m_new_diagram: {
            title: 'Nuevo diagrama',
            subtitle: 'Elige un motor de base de datos',
            open_diagram: 'Abrir diagrama',
            create_diagram: 'Crear diagrama',
            no_workspace: 'Crea primero un espacio de trabajo para iniciar un diagrama.',
            build_something_new: 'Creemos algo nuevo',
            create_diagram_section: 'Crear diagrama',
            clone_template_btn: 'Duplicar plantilla',
        },
        m_diagram_name: {
            enter_new_name: 'Introduce un nuevo nombre de diagrama',
        },
        m_diagram_clone: {
            header: 'Duplicar diagrama',
            copy_of_title: 'Copia de {{title}}',
        },
        m_diagram_rename: {
            header: 'Renombrar diagrama',
        },
        m_template_clone: {
            header: 'Crear un diagrama a partir de una plantilla',
        },
        m_diagram_delete: {
            header: 'Eliminar diagrama',
            desc_prefix: 'Se eliminará: ',
        },
        m_diagram_archive: {
            header: 'Archivar diagrama',
            desc_prefix: 'Se archivará: ',
        },
        m_diagram_restore: {
            header: 'Restaurar diagrama',
            desc_prefix: 'Se restaurará: ',
        },
        m_diagram_import: {
            sql_name: 'Importar código SQL',
            dbml_name: 'Importar código DBML',
            // NOTE: en.js flags this placeholder copy as mismatched content (reads like
            // feedback-modal copy, not an SQL/DBML paste prompt). Kept verbatim in
            // translation since fixing the copy is a product call, not a translation one.
            placeholder: '¡Nos encantaría conocer tu opinión!',
        },
        m_diagram_not_found: {
            header: 'Diagrama no encontrado',
            desc: 'No pudimos encontrar el diagrama que buscas.',
            back_to_app: 'Volver a la app',
        },
        m_diagram_share: {
            header: 'Compartir diagrama – {{title}}',
            owner_only_invite: 'Solo el propietario puede invitar a nuevos miembros',
            invited_to_workspace: 'Invitado al espacio de trabajo',
            you: 'tú',
            email_placeholder: 'Introduce el correo',
            email_already_in_list: 'el correo ya está en la lista',
            will_be_invited_to_workspace: 'será invitado al espacio de trabajo',
        },
        m_invite_people: {
            header: 'Invitar al espacio de trabajo',
        },
        m_invite_revoke: {
            header: 'Quitar invitación',
            desc_prefix: 'Quitar invitación de ',
            desc_suffix: 'La invitación dejará de funcionar.',
        },
        m_member_remove: {
            header: 'Quitar miembro',
            desc_prefix: '¿Quitar a ',
            desc_suffix: ' de este espacio de trabajo? Perderá el acceso.',
        },
        m_template_details: {
            preview: 'Vista previa',
            use_template: 'Usar plantilla',
        },
        m_workspace_create: {
            header: 'Crear un nuevo espacio de trabajo',
            name_label: 'Nombre',
            setup_config_label: 'Configuración inicial',
            setup_config_value: 'Espacio de trabajo vacío',
            template_structure_label: 'Plantilla/Estructura',
            template_structure_value: 'Precargar estructura',
            placeholder: 'Introduce el nombre del espacio de trabajo',
            create_button: 'Crear espacio de trabajo',
            creating: 'Creando tu espacio de trabajo...',
        },
        m_workspace_delete: {
            header: 'Eliminar espacio de trabajo',
            desc_prefix: 'Se eliminará permanentemente: ',
            confirm_prefix: 'Escribe ',
            confirm_suffix: ' para confirmar.',
        },
        m_workspace_leave: {
            header: 'Salir del espacio de trabajo',
            desc_prefix: 'Esto te eliminará de ',
            desc_suffix: '. Deberás ser invitado de nuevo para volver a unirte.',
        },
        m_workspace_menu: {
            manage_members: 'Administrar miembros',
            switch_workspace: 'Cambiar espacio de trabajo',
            workspaces_label: 'Espacios de trabajo',
            create_workspace: 'Crear un espacio de trabajo...',
            switching: 'Cambiando',
        },
        m_profile_menu: {
            profile: 'Perfil',
            onboarding: 'Introducción',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Lleva tu colaboración al siguiente nivel', description: 'Mejora tu plan para desbloquear más roles de acceso como Administrador, Editor, Comentador y Lector.' },
            workspaces: { title: '¡Estás creciendo rápido!', description: 'Mejora tu plan para crear y administrar más espacios de trabajo para tus proyectos y equipos.' },
            workspaces_canvas: { title: 'Amplía tus espacios de trabajo', description: 'Mejora tu plan para crear y administrar más espacios de trabajo para tus proyectos y equipos.' },
            members: { title: 'Colabora a gran escala', description: 'Mejora tu plan para incorporar más miembros a tu espacio de trabajo y colaborar de forma más eficaz.' },
            diagrams: { title: '¡Estás creciendo rápido!', description: 'Mejora tu plan para crear más diagramas y hacer crecer tus proyectos con confianza.' },
            tables: { title: 'Crea sin límites', description: 'Mejora tu plan para añadir más tablas y seguir creando diagramas más grandes y detallados.' },
            columns: { title: 'Crea sin límites', description: 'Mejora tu plan para añadir más columnas y seguir creando diagramas más grandes y detallados.' },
            notes: { title: 'Crea sin límites', description: 'Mejora tu plan para añadir más notas y seguir creando diagramas más grandes y detallados.' },
            areas: { title: 'Crea sin límites', description: 'Mejora tu plan para añadir más áreas y seguir creando diagramas más grandes y detallados.' },
            pens: { title: 'Crea sin límites', description: 'Mejora tu plan para añadir más dibujos y seguir creando diagramas más grandes y detallados.' },
            default_title: 'Lleva tu colaboración al siguiente nivel',
            default_title_canvas: 'Mejora tu rendimiento',
        },
        m_pricing_plans: {
            title: 'Mejora tu plan',
            subtitle: 'Siempre puedes mejorar o bajar de plan más adelante',
            monthly: 'Mensual',
            annually: 'Anual',
            billed_annually: 'Facturación anual',
            billed_monthly: 'Facturación mensual',
            free_for_everyone: 'Gratis para todos',
            current_plan: 'Plan actual',
            will_be_available_soon: 'Estará disponible pronto',
            price_period_user_month: '/usuario/mes',
            plan_free: {
                name: 'Gratis',
                button: 'Cambiar plan',
                feature_realtime: 'Colaboración en tiempo real',
                feature_members: '4 miembros / espacio de trabajo',
                feature_diagrams: '4 diagramas / espacio de trabajo',
                feature_tables: '40 tablas / diagrama',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Todas las funciones de Gratis +',
                feature_members: 'Miembros ilimitados',
                feature_diagrams: 'Diagramas ilimitados',
                feature_tables: 'Tablas ilimitadas',
                feature_history: 'Historial de versiones',
                feature_admin_roles: 'Roles de administrador',
            },
        },
        sidebar: {
            new: 'Nuevo',
            pinned_diagrams: 'Diagramas fijados',
            pin_hint: 'Fija diagramas para verlos aquí',
            expand_sidebar: 'Expandir barra lateral',
            home_aria: 'Inicio de DB Design',
            open_menu: 'Abrir menú',
            close_menu: 'Cerrar menú',
            sidebar_menu_aria: 'Menú de la barra lateral',
            plan_suffix: 'plan',
            diagram_options: 'Opciones del diagrama',
            pin: 'Fijar',
            unpin: 'Dejar de fijar',
            edit_details: 'Editar detalles',
            see_details: 'Ver detalles',
            invite_people: 'Invitar personas',
            collapse_sidebar: 'Contraer barra lateral',
            close_sidebar: 'Cerrar barra lateral',
            open_sidebar: 'Abrir barra lateral',
            open_new_tab: 'Abrir en una pestaña nueva',
        },
        focus_controls: {
            show_top: 'Mostrar controles superiores',
            hide_top: 'Ocultar controles superiores',
            show_left: 'Mostrar controles izquierdos',
            hide_left: 'Ocultar controles izquierdos',
        },
        m_keyboard_shortcuts: {
            title: 'Atajos de teclado',
            general: {
                title1: 'General',
                title2: '',
                items: {
                    new_diagram: 'Crear diagrama',
                    new_chat: 'Nuevo chat',
                    search: 'Acciones rápidas o búsqueda',
                    preferences: 'Preferencias',
                    settings: 'Configuración',
                    keyboard_shortcuts: 'Atajos de teclado',
                    toggle_sidebar: 'Mostrar/ocultar barra lateral',
                    toggle_theme: 'Cambiar tema',
                },
            },
            ctrl_left: {
                title1: 'Controles',
                title2: '(Izquierda)',
                items: {
                    mouse_sel: 'Selección con mouse / Modo mano',
                    table: 'Tabla',
                    line: 'Línea',
                    area: 'Área',
                    note: 'Nota',
                    comment: 'Comentario',
                    pen: 'Lápiz',
                    undo: 'Deshacer',
                    redo: 'Rehacer'
                }
            },
            ctrl_top_left: {
                title1: 'Controles',
                title2: '(Arriba a la izquierda)',
                items: {
                    export_img: 'Exportar imagen',
                    search: 'Buscar',
                    editor_panel: 'Panel del editor',
                    zoom_to_fit: 'Ajustar a la pantalla',
                }
            },
            ctrl_bottom_right: {
                title1: 'Controles',
                title2: '(Abajo a la derecha)',
                items: {
                    minimap: 'Minimapa',
                    full_screen: 'Pantalla completa',
                    zoom_in: 'Acercar',
                    zoom_out: 'Alejar',
                    zoom_100: 'Zoom al 100 %'
                }
            },
            ctx_tab: {
                title1: 'Menú contextual',
                title2: '(Tabla)',
                items: {
                    dupl_tab: 'Duplicar tabla',
                    del_tab: 'Eliminar tabla'
                }
            },
            ctx_del_tab: {
                title1: 'Menú contextual',
                title2: '(Eliminar tabla)',
                items: {
                    yes: 'Sí',
                    no: 'No'
                }
            },
            ctx_tab_col: {
                title1: 'Menú contextual',
                title2: '(Columna)', // Columna de tabla
                items: {
                    add_col_below: 'Agregar nueva columna debajo',
                    focus_col_above: 'Foco en la columna superior',
                    focus_col_below: 'Foco en la columna inferior',
                    move_col_up: 'Mover columna arriba',
                    move_col_down: 'Mover columna abajo',
                    dupl_col: 'Duplicar columna',
                    del_col: 'Eliminar columna'
                }
            },
            ctx_line: {
                title1: 'Menú contextual',
                title2: '(Línea)',
                items: {
                    del_line: 'Eliminar línea'
                }
            },
            ctx_area: {
                title1: 'Menú contextual',
                title2: '(Área)',
                items: {
                    dupl_area: 'Duplicar área',
                    del_area: 'Eliminar área'
                }
            },
            ctx_multi: {
                title1: 'Menú contextual',
                title2: '(Multiselección)',
                items: {
                    select_all: 'Seleccionar todos los elementos',
                    create_area_for_select_els: 'Crear área para los elementos seleccionados',
                    dupl_select_els: 'Duplicar elementos seleccionados',
                    del_select_els: 'Eliminar elementos seleccionados'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Selección con mouse',
                table: 'Tabla',
                line: 'Línea',
                area: 'Área',
                note: 'Nota',
                comment: 'Comentario',
                pen: 'Lápiz',
                undo: 'Deshacer',
                redo: 'Rehacer'
            },
            ctrl_top_left: {
                home: 'Inicio',
                name: 'Información del diagrama',
                editor: 'Editor',
                search: 'Búsqueda',
                export: 'Opciones de exportación',
                view_mode: 'Modo de visualización',
                zoom_to_fit: 'Ajustar a la pantalla',
                grid: 'Vista de cuadrícula',
                history: 'Historial',
                main_menu: 'Menú principal',
                new_diagram: 'Nuevo diagrama',
            },
            ctrl_top_right: {
                feature_req: 'Solicitud de función',
                feedback: 'Enviar comentarios',
                sign_in: 'Iniciar sesión',
                quick_share: 'Compartir rápido'
            },
            ctrl_bottom_right: {
                full_screen: 'Pantalla completa',
                minimap: 'Minimapa',
                zoom_out: 'Alejar',
                zoom_100: 'Zoom al 100 %',
                zoom_in: 'Acercar',
                info: 'Información y recursos'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Predeterminado',
                        blue: 'Azul',
                        green: 'Verde',
                        red: 'Rojo',
                        purple: 'Morado',
                        violet: 'Violeta'
                    },
                    borders: {
                        none: 'Ninguno',
                        solid: 'Sólido',
                        dashed: 'Discontinuo',
                        dotted: 'Punteado'
                    },
                    color: 'Color',
                    border: 'Borde',
                    description: 'Descripción',
                    description_table_place: 'Descripción de la tabla',
                    description_column_place: 'Descripción de la columna',
                    description_line_place: 'Descripción de la línea',
                    description_note_place: 'Descripción de la nota',
                    description_area_place: 'Descripción del campo',
                    description_pen_place: 'Descripción del lápiz',
                    hide_menu: 'Ocultar menú',
                    show_menu: 'Mostrar menú'
                },
                tab_col: {
                    add_col_below: 'Agregar columna debajo',
                    add_col_above: 'Agregar columna encima',
                    key: 'Key',
                    keys: {
                        none: 'Ninguna',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Ninguno',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Mover columna abajo',
                    move_col_up: 'Mover columna arriba',
                    more_functions: 'Más funciones'
                },
                line: {
                    change_connects: 'Cambiar conectores',
                    connects: {
                        empty: 'Vacío',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Filtrar elementos'
                },
                note: {
                    link_placeholder: 'Introduce un enlace',
                    link_apply: 'Añadir',
                    link_remove: 'Quitar',
                    link_edit: 'Editar',
                    link_needs_selection: 'Selecciona texto para enlazar',
                    bulleted_list: 'Lista',
                    numbered_list: 'Lista numerada',
                    font_style: 'Estilo de fuente',
                    alignment: 'Alineación',
                    align_left: 'Izquierda',
                    align_center: 'Centro',
                    align_right: 'Derecha',
                    link: 'Enlace',
                    monospace: 'Monoespaciada',
                    bold: 'Negrita',
                    italic: 'Cursiva',
                    underline: 'Subrayado',
                    strikethrough: 'Tachado',
                },
                multi: {
                    filter: 'Filtrar selección',
                    create_area: 'Crear área'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Completo',
            keys_only: 'Solo claves',
            names_only: 'Solo nombres'
        },
        dropdown_ctrl_grid: {
            none: 'Ninguno',
            lines: 'Líneas',
            dots: 'Puntos',
        },
        dropdown_ctrl_export: {
            export_img: 'Exportar imagen',
            export_code: 'Exportar código SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Volver al inicio',
            sign_in: 'Iniciar sesión',
            preferences: 'Preferencias',
            new_project: 'Nuevo proyecto',
            import_diagram: 'Importar diagrama',
            duplicate_diagram: 'Duplicar diagrama',
            keyboard_shortcuts: 'Atajos de teclado',
            languages: 'Idiomas',
            view: 'Vista',
            upgrade_plan: 'Mejorar plan',
            language: 'Idioma',
            mouse_trackpad: 'Ratón o panel táctil',
            background_color: 'Color de fondo',
            grid_layout: 'Diseño de cuadrícula',
            view_mode: 'Modo de visualización',
            show_align_lines: 'Mostrar líneas de alineación',
            show_members_cursors: 'Mostrar cursores de los miembros',
            show_comments: 'Mostrar comentarios',
            undo_redo_controls: 'Controles de deshacer/rehacer',
            show_scrollbars: 'Mostrar barras de desplazamiento',
            opt_auto: 'Automático',
            opt_trackpad: 'Panel táctil',
            opt_mouse: 'Ratón',
            opt_default: 'Oscuro (predeterminado)',
            opt_gray: 'Gris',
            opt_blue: 'Azul',
            opt_purple: 'Morado',
            opt_violet: 'Violeta',
            opt_green: 'Verde',
            opt_red: 'Rojo',
            opt_yellow: 'Amarillo',
            opt_dots: 'Puntos',
            opt_lines: 'Líneas',
            opt_none: 'Ninguno',
            opt_full: 'Completo',
            opt_keys: 'Claves',
            opt_names: 'Nombres',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Enviar comentarios',
            keyboard_shortcuts: 'Atajos de teclado',
            languages: 'Idiomas',
            homepage: 'Página de inicio'
        },
        n: {
            default: 'Cargando…',
            file_ready_to_download: 'El archivo está listo para descargar',
            code_copied: 'El código se ha copiado',
            link_copied: 'El enlace se ha copiado',
            username_copied: 'Nombre de usuario copiado al portapapeles',
            email_copied: 'Correo copiado al portapapeles',
            please_enter_message: 'Por favor, introduce un mensaje',
            invalid_email: 'El correo electrónico no es válido',
            note_link_unsupported_protocol: 'Tipo de enlace no compatible. Usa https, http, mailto.',
            something_wrong_contact: 'Se produjo un error. Recarga la página o contáctanos.',
            something_wrong: 'Se produjo un error. Recarga la página.',
            sending: 'Enviando…',
            request_sent: 'Solicitud enviada. ¡Gracias!',

            please_enter_email: 'Introduce el correo electrónico',
            changing: 'Cambiando...',
            role_changed: 'Rol cambiado',
            removing: 'Quitando...',
            member_removed: 'Miembro eliminado',
            inviting: 'Invitando...',
            invite_sent: 'Invitación enviada',
            added_to_diagram: 'Añadido al diagrama',
            invite_removed: 'Invitación eliminada',
            role_not_allowed_on_plan: 'Este rol no está disponible en tu plan. Mejora tu plan para asignarlo.',
            already_diagram_member: 'Esta persona ya tiene acceso al diagrama.',
            cannot_invite_to_workspace: 'Pídele a un administrador del espacio de trabajo que invite a esta persona.',
            saving: 'Guardando...',
            saved: 'Guardado',
            diagram_renamed: 'Diagrama renombrado',
            diagram_updated: 'Diagrama actualizado',
            duplicating: 'Duplicando...',
            diagram_duplicated: 'Diagrama duplicado',
            deleting: 'Eliminando...',
            diagram_archived: 'Diagrama archivado',
            diagram_deleted: 'Diagrama eliminado',
            restoring: 'Restaurando...',
            diagram_restored: 'Diagrama restaurado',
            diagram_pinned: 'Diagrama fijado',
            diagram_unpinned: 'Diagrama sin fijar',
            creating: 'Creando...',
            diagram_created: 'Diagrama creado',
            forbidden: 'No tienes acceso a eso.',
            invite_already_pending: 'This person already has a pending invitation.',
            already_member: 'Ya es miembro del espacio de trabajo',
            cannot_invite_self: 'No puedes invitarte a ti mismo',
            workspace_not_found: 'Workspace not found. Refresh the page and try again.',
            diagram_not_found: 'Diagrama no encontrado.',
            has_diagram_members: 'El diagrama tiene miembros activos',
            seat_limit_reached: 'Has alcanzado el límite de plazas de tu plan. Mejora tu plan para invitar a más personas.',
            feature_not_in_plan: 'Esta función no está incluida en tu plan actual.',
            subscription_expired: 'Tu suscripción ha caducado. Renuévala para seguir usando esto.',
            subscription_inactive: 'Tu suscripción está inactiva. Actualiza tu método de pago.',
            plan_limit_generic: 'Tu plan no permite esta acción. Mejora tu plan para continuar.',

            // Auth / profile
            session_expired: 'Tu sesión ha caducado — inicia sesión de nuevo.',
            profile_updated: 'Perfil actualizado',
            profile_update_failed: 'No se pudo actualizar el perfil.',
            account_delete_failed: 'No se pudo eliminar la cuenta.',

            // Preferences
            couldnt_save: 'No se pudieron guardar los cambios',
            try_again: 'Se produjo un error. Inténtalo de nuevo.',

            // Workspace
            not_workspace_member: 'No eres miembro de ese espacio de trabajo.',
            workspace_switch_failed: 'No se pudo cambiar de espacio de trabajo. Inténtalo de nuevo.',
            workspace_create_failed: 'No se pudo crear el espacio de trabajo. Inténtalo de nuevo.',
            invalid_workspace_name: 'Nombre de espacio de trabajo no válido',
            workspace_updated: 'Espacio de trabajo actualizado',
            workspace_update_failed: 'No se pudo actualizar el espacio de trabajo. Inténtalo de nuevo.',
            last_owner_cannot_leave: 'Eres el único propietario. Asigna la propiedad a otra persona o elimina el espacio de trabajo antes de salir.',
            workspace_leave_failed: 'No se pudo salir del espacio de trabajo. Inténtalo de nuevo.',
            workspace_delete_forbidden: 'Solo el propietario del espacio de trabajo puede eliminarlo.',
            workspace_has_active_billing: 'Cancela la suscripción de este espacio de trabajo antes de eliminarlo.',
            workspace_deleted: 'Espacio de trabajo eliminado',
            workspace_delete_failed: 'No se pudo eliminar el espacio de trabajo. Inténtalo de nuevo.',
            member_remove_forbidden: 'No tienes permiso para quitar a este miembro.',
            member_remove_failed: 'No se pudo quitar al miembro. Inténtalo de nuevo.',
            cannot_remove_self: 'Usa "Salir del espacio de trabajo" para eliminarte a ti mismo.',
            cannot_remove_last_owner: 'Un espacio de trabajo siempre debe tener un propietario. Asigna primero la propiedad a otra persona.',
            invite_revoke_forbidden: 'No tienes permiso para revocar esta invitación.',
            invite_revoke_failed: 'No se pudo revocar la invitación. Inténtalo de nuevo.',
        },
        dashboard: {
            doc_title: 'Diagramas',
            filter_all: 'Todos',
            filter_mydiagrams: 'Mis diagramas',
            filter_shared: 'Compartidos conmigo',
            filter_archived: 'Archivados',
            empty_all: 'No hay diagramas en "Todos los diagramas"',
            empty_mydiagrams: 'No hay diagramas en "Mis diagramas"',
            empty_shared: 'No hay diagramas en "Compartidos conmigo"',
            empty_archived: 'No hay diagramas en "Archivados"',
            example_diagram_badge: 'Diagrama de ejemplo',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Volver a la app',
                group_personal: 'Personal',
                group_organization: 'Organización',
                billing: 'Facturación',
            },
            profile: {
                member_since: 'Miembro desde {{date}}',
                general: 'General',
                email: 'Correo electrónico',
                full_name: 'Nombre completo',
                full_name_placeholder: 'Escribe tu nombre',
                account_protection: 'Protección de la cuenta',
                mfa_label: 'Autenticación multifactor (MFA)',
                mfa_sub: 'Capa adicional de seguridad para tu cuenta · Próximamente',
                mfa_enable: 'Activar MFA',
                mfa_soon_tooltip: 'Estará disponible próximamente',
                workspace_access: 'Acceso al espacio de trabajo',
                leave_workspace: 'Salir del espacio de trabajo',
                leave_workspace_sub: 'Eliminarte del espacio de trabajo',
                leave_owner_tooltip: 'Transfiere la propiedad antes de salir del espacio de trabajo',
            },
            workspace: {
                header: 'Espacio de trabajo',
                general: 'General',
                name_label: 'Nombre del espacio de trabajo',
                name_placeholder: 'nombre del espacio de trabajo',
                stat_member_singular: 'Miembro',
                stat_member_plural: 'Miembros',
                stat_team_singular: 'Equipo',
                stat_team_plural: 'Equipos',
                members_section: 'Miembros',
                no_members: 'Sin miembros',
                count_member_singular: 'miembro',
                count_member_plural: 'miembros',
                view_members_btn: 'Ver miembros',
                danger_zone: 'Zona de peligro',
                delete_workspace: 'Eliminar espacio de trabajo',
                delete_workspace_sub: 'Esto eliminará el espacio de trabajo de forma permanente',
                delete_owner_only_tooltip: 'Solo los propietarios pueden eliminar espacios de trabajo',
                delete_cancel_sub_tooltip: 'Cancela tu suscripción antes de eliminar el espacio de trabajo',
            },
            members: {
                header: 'Miembros',
                col_name: 'Nombre',
                col_email: 'Correo electrónico',
                col_role: 'Rol',
                col_joined: 'Se unió',
                active_members: 'Miembros activos',
                invited_section: 'Invitados',
                no_members: 'Aún no hay miembros.',
                options_aria: 'Opciones',
                leave_workspace_item: 'Salir del espacio de trabajo...',
                remove_member_item: 'Eliminar miembro...',
                remove_owner_only_tooltip: 'Solo los propietarios pueden eliminar miembros',
                remove_owner_row_tooltip: 'El propietario no se puede eliminar del espacio de trabajo',
                remove_invite_item: 'Eliminar invitación...',
                role_invited_suffix: '{{role}} (Invitado)',
            },
            preferences: {
                section_general: 'General',
                section_diagram_defaults: 'Configuración del diagrama',
                section_diagram_views: 'Vistas del diagrama',
                section_notifications: 'Notificaciones',
                theme_label: 'Tema de la interfaz',
                theme_sub: 'Selecciona el esquema de color de tu interfaz',
                theme_dark: 'Oscuro',
                theme_light: 'Claro',
                theme_system: 'Sistema',
                language_sub: 'Selecciona el idioma de tu interfaz',
                timezone_label: 'Zona horaria',
                timezone_sub: 'Selecciona tu zona horaria',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawái',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Hora del Pacífico',
                    denver: 'GMT-07:00 — Hora de la Montaña',
                    chicago: 'GMT-06:00 — Hora del Centro',
                    new_york: 'GMT-05:00 — Hora del Este',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azores',
                    london: 'GMT+00:00 — Londres',
                    paris: 'GMT+01:00 — París, Berlín',
                    kyiv: 'GMT+02:00 — Kyiv, Atenas',
                    istanbul: 'GMT+03:00 — Estambul',
                    dubai: 'GMT+04:00 — Dubái',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — India',
                    dhaka: 'GMT+06:00 — Daca',
                    bangkok: 'GMT+07:00 — Bangkok, Yakarta',
                    shanghai: 'GMT+08:00 — Pekín, Singapur',
                    tokyo: 'GMT+09:00 — Tokio, Seúl',
                    sydney: 'GMT+10:00 — Sídney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Elige los controles de navegación del lienzo',
                background_sub: 'Elige un color de fondo para el lienzo',
                grid_sub: 'Elige el diseño de cuadrícula del lienzo',
                show_align_lines_sub: 'Mostrar líneas al alinear objetos',
                show_cursors_sub: 'Mostrar los cursores de otros colaboradores',
                show_comments_sub: 'Mostrar comentarios en el lienzo',
                show_scrollbars_sub: 'Mostrar barras de desplazamiento al navegar por el lienzo',
                show_undo_redo_label: 'Mostrar controles de deshacer/rehacer',
                show_undo_redo_sub: 'Mostrar controles para deshacer y rehacer cambios',
                notif_shared_label: 'Diagrama compartido conmigo',
                notif_shared_sub: 'Cuando alguien comparte un diagrama conmigo',
                notif_mentions_label: 'Menciones en comentarios',
                notif_mentions_sub: 'Cuando alguien me menciona con @ en un comentario',
                notif_updates_label: 'Novedades del producto',
                notif_updates_sub: 'Actualizaciones mensuales sobre nuevas funciones y mejoras',
                show: 'Mostrar',
                hide: 'Ocultar',
                on: 'Activado',
                off: 'Desactivado',
            },
            billing: {
                header: 'Facturación',
                plan_free: 'Plan gratuito',
                status_current: 'Actual',
                no_renewal_needed: 'No se requiere renovación',
                payment_header: 'Pago',
                no_payments: 'Sin pagos',
                invoices_header: 'Facturas',
                no_invoices: 'Sin facturas',
            },
            usage: {
                doc_title: 'Uso',
                overview_title: 'Resumen',
                resource_limits_title: 'Límites de recursos',
                label_diagrams: 'Diagramas',
                label_tables: 'Tablas',
                label_areas: 'Áreas',
                label_notes: 'Notas adhesivas',
                label_members: 'Miembros',
                label_tables_per_diagram: 'Tablas / Diagrama',
                label_areas_per_diagram: 'Áreas / Diagrama',
                label_notes_per_diagram: 'Notas / Diagrama',
                need_more_title: '¿Necesitas más?',
                need_more_free: 'Mejora a Basic para más diagramas, historial de versiones y soporte prioritario.',
                need_more_paid: 'Mejora a Professional para diagramas ilimitados, más puestos y funciones avanzadas.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Página no encontrada',
                dont_have_access_to_diagram: 'No tienes acceso a este diagrama o puede que ya no exista.',
                back_home: 'Volver al inicio'
            },
            error: {
                title: 'Error',
                link_is_invalid: 'Este enlace no es válido o se introdujo incorrectamente.',
                something_wrong: 'Se produjo un error.',
                back_home: 'Volver al inicio',
                please_try_later: 'Inténtalo más tarde',
            },
            billing_success: {
                doc_title: 'Plan actualizado',
                heading: 'Pago exitoso',
                subtitle: 'Tu plan se ha actualizado correctamente.',
                cta: 'Empezar a diseñar',
            },
            email_verified: {
                doc_title: 'Correo verificado',
            },
            forgot_password: {
                doc_title: 'Olvidé mi contraseña',
            },
            password_updated: {
                doc_title: 'Contraseña actualizada',
            },
            reset_password: {
                doc_title: 'Restablecer contraseña',
            },
            check_email: {
                doc_title: 'Revisa tu correo',
            },
            sign_in: {
                doc_title: 'Iniciar sesión en {{product}}',
            },
            sign_up: {
                doc_title: 'Regístrate en {{product}}',
            },
        },
    }
};

export const esMeta = {
    lang_origin: 'Español',
    lang_eng: 'Spanish',
    lang_code: 'es',
};
